module.exports = __webpack_public_path__ + "assets/img/4.e0d0e75c.jpg";